import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { UserCompany } from '@src/api/types/userCompany';

export type CompanyShowResponse = {
  company: UserCompany;
};

export const companyShowApiClient = {
  show: async (): Promise<ApiResult<CompanyShowResponse>> => {
    return await axiosClient.get(`/company/company`);
  },
};
